import { Component, OnInit } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-override-stock',
  templateUrl: './override-stock.component.html',
  styleUrls: ['./override-stock.component.css']
})
export class OverrideStockComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OverrideStockComponent>
    ) { }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  overrideStock(){
    this.dialogRef.close('ok');
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/override-stock/override-stock.component.ts